export enum StatisticsValueType {
    PERCENTAGE = 'percentage',
    INT = 'integer',
    FLOAT = 'float',
    STRING = 'string',
}
